// extracted by mini-css-extract-plugin
module.exports = {"cabecera":"Sleep_cabecera__35yJh","cabecera_banner":"Sleep_cabecera_banner__3EWds","cabecera_banner_titulo":"Sleep_cabecera_banner_titulo__2TQUl"};